import { Star } from 'lucide-react';
import { testimonials } from '@/mocks/homeData';

export default function TestimonialsSection() {
  return (
    <section className="bg-navy-600 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="text-xs font-semibold tracking-widest text-gold-400 uppercase">Testimonials</span>
            <h2 className="mt-3 text-3xl md:text-4xl lg:text-5xl font-bold text-white">
              Trusted by Consultancies Across India
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-6 md:gap-8">
            {testimonials.map((t) => (
              <div
                key={t.name}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-6 md:p-8 border border-white/10 hover:bg-white/15 transition-all"
              >
                {/* Stars */}
                <div className="flex gap-1 mb-4">
                  {Array.from({ length: t.stars }).map((_, i) => (
                    <Star key={i} className="w-5 h-5 text-gold-400 fill-gold-400" />
                  ))}
                </div>

                <p className="text-white/90 text-sm md:text-base leading-relaxed italic">
                  &ldquo;{t.quote}&rdquo;
                </p>

                <div className="mt-6 pt-4 border-t border-white/10">
                  <div className="text-white font-semibold text-sm">{t.name}</div>
                  <div className="text-white/60 text-xs mt-0.5">{t.role}</div>
                  <div className="text-white/40 text-xs mt-0.5">{t.location}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}